import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { MapElement } from '../../../shared/map/map-element.model';
import { Point } from 'geojson';
import { BaseComponent } from '../../../components/general/base/base.component';
import { InfoActionService } from './info-action.service';
import { Layer } from '../../../shared/map/layer/layer.model';
import { TabId } from '../../../custom/vrgroup/train-info/train-info/train-info.component';
import { MapService } from '~app/shared/map/map.service';

@Component({
  selector: 'qm-info-action',
  templateUrl: './info-action.component.html',
  styleUrls: ['./info-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoActionComponent extends BaseComponent implements OnInit {

  @Input() public selectedLayer: Layer;
  @Input() public icon?: string = 'info';
  @Input() public tabId: TabId;
  @Input() protected selectedFeature: MapElement<Point>;
  @Output() public detailsOpened: EventEmitter<void> = new EventEmitter();

  constructor(
    private mapService: MapService,
    private infoActionService: InfoActionService,
    protected cdr: ChangeDetectorRef
  ) {
    super();
    this.name = 'InfoActionComponent';
  }

  ngOnInit() {
  }

   /**
   * Select currently hovered feature
   */
  public openDetails() {
    this.mapService.changeCurrentFeature(this.selectedFeature);
    this.infoActionService.openDetails(this.selectedLayer, this.selectedFeature, this.tabId);
    this.detailsOpened.emit();
  }
}
